import {getParameterByName} from '../../../shared/scripts/ui_utils/ClientUtils.ts'
import {UIWStoreBodyController} from './UIWStoreBodyController.ts'
import {notificationController} from '../../../shared/scripts/EntryShared.ts'
import {UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController.ts'
import {UIStoreState} from '../../../shared/scripts/store/UIStoreState.ts'
import {UIStoreController} from '../../../shared/scripts/store/UIStoreController.ts'
import {CA} from '../../../shared/scripts/analytics/Analytics.ts'

export class UIWStoreController extends UIStoreController {
    protected storeState: UIStoreState
    bodyController: UIWStoreBodyController
    readonly headerCoinsContainer: HTMLDivElement

    constructor() {
        super()
        this.init()
        UIWStoreController.showSuccessBanner()
    }

    protected init() {
        this.storeState = new UIStoreState(this)
        this.bodyController = new UIWStoreBodyController(this.storeState)
        this.bodyController.onStoreViewVisible()
    }

    private static showSuccessBanner() {
        const purchaseSuccess = getParameterByName('purchase-success')
        if(purchaseSuccess != '1') return
        notificationController.show({key: 'strings:storePage.success.purchaseSuccess'}, UITopNotificationType.Success)
        CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.PurchaseCompleted)
    }
}
